import { useSelector } from "react-redux";
import { selectCanEdit } from "../app/userSlice";

export const useReadOnly = () => {
  const canEdit = useSelector(selectCanEdit);
  return !canEdit;
};
